import { useMutation } from '@tanstack/react-query';
import { isNotNil, pickBy } from 'rambda';
import { z } from 'zod';
import type { RespondedType, ResponseError } from '@/models/response';
import { addToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';
import { nameSchema } from '@/utils/schemas';

export default function useUpdateGroupDetails(groupId: Nullable<number>) {
  return useMutation<RespondedType, ResponseError, Partial<UpdateGroupRequest>>({
    mutationKey: ['/UpdateGroup', groupId],
    mutationFn: (params) => fetcher('/UpdateGroup', { ...pickBy(isNotNil, params), GroupID: groupId }),
    onSettled: (data, error) =>
      addToast({
        type: data ? 'success' : 'error',
        message: data?.Msg ?? error?.message,
      }),
  });
}

const updateGroupRequestScheme = z
  .object({
    GroupName: nameSchema,
    GroupImg: z.string(),
    AddFriend: z.union([z.literal(0), z.literal(1)]),
    JoinType: z.union([z.literal(0), z.literal(1)]),
  })
  .partial();

type UpdateGroupRequest = z.infer<typeof updateGroupRequestScheme>;
